"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const Phone_1 = __importDefault(require("@kyruus/react-ikons/Phone"));
const ui_theme_1 = require("@kyruus/ui-theme");
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const messages_1 = __importDefault(require("../../../lib/messages"));
const PhoneNumberLink_1 = __importDefault(require("../../PhoneNumberLink/PhoneNumberLink"));
const ProviderLocations_gmap_utils_1 = require("../ProviderLocations.gmap.utils");
const Location_utils_1 = require("./Location.utils");
const LocationAddress_1 = __importDefault(require("./LocationAddress"));
const styles_1 = require("./styles");
const NonBookableLocation = (0, ui_theme_1.withTheme)((_a) => {
    var { theme, name, phone, street1 = '', street2 = '', suite = '', city = '', state = '', zip = '' } = _a, props = __rest(_a, ["theme", "name", "phone", "street1", "street2", "suite", "city", "state", "zip"]);
    return (react_1.default.createElement(styles_1.NonBookableLocationContainer, { "data-testid": props['data-testid'] || 'ProviderLocations__Location', className: "NonBookableLocation" },
        react_1.default.createElement("div", null,
            react_1.default.createElement(Phone_1.default, { size: "18px", color: (0, ProviderLocations_gmap_utils_1.getNonBookableLocationColor)(theme) }),
            react_1.default.createElement("div", { itemProp: "address", itemScope: true, itemType: "http://schema.org/PostalAddress" },
                react_1.default.createElement(Location_utils_1.Name, null, name),
                props.children || (react_1.default.createElement(LocationAddress_1.default, { street1: street1, street2: street2, suite: suite, city: city, state: state, zip: zip })),
                props.locationMessage)),
        !props.locationMessage && (react_1.default.createElement(styles_1.LocationMessage, { "data-testid": "LocationMessage" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.notBookableLocation)),
            phone && (react_1.default.createElement("strong", null,
                react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone })))))));
});
NonBookableLocation.propTypes = {
    name: prop_types_1.string.isRequired,
    street1: prop_types_1.string,
    street2: prop_types_1.string,
    suite: prop_types_1.string,
    city: prop_types_1.string,
    state: prop_types_1.string,
    zip: prop_types_1.string,
    phone: prop_types_1.string,
    'data-testid': prop_types_1.string,
    children: prop_types_1.object,
    locationMessage: prop_types_1.object
};
exports.default = NonBookableLocation;
//# sourceMappingURL=NonBookableLocation.js.map